import create from 'zustand'
import { RebrandedBrandColors } from '@conexasaude/conexa-hero'
import { cnxTokens } from '@conexasaude/hero-tokens'
import { removeCache, setCache } from '@/utils/cache'
import { generateRebrandedTheme, getInitialRebrandedTheme } from './themeUtils'
import { RebrandedThemeGenerator } from './types'

export const useRebrandedThemeGenerator = create<RebrandedThemeGenerator>()(
  set => {
    return {
      rebrandedTheme: getInitialRebrandedTheme(),
      setRebrandedTheme: (themeColors: RebrandedBrandColors | null): void => {
        if (themeColors) {
          const generetadedTheme = generateRebrandedTheme(themeColors)

          set({ rebrandedTheme: generetadedTheme })
          setCache('rebranded-colors', themeColors)
        } else {
          set({
            rebrandedTheme: generateRebrandedTheme(cnxTokens.colors.brand),
          })
          removeCache('rebranded-colors')
        }
      },
    }
  },
)
